/*                */
import { fontSize } from "../../../build/src/chunks/fontSize.js";
export const maxWidth = () => 432; /*                      */
export const textSpacing = () => 12;
export const showEasing = () => "cubic-bezier(0,0,0.4,1)";
export const showDuration = () => 125; /*                      */
export const shadow = () => "drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.25)) drop-shadow(0px 4px 6px rgba(0, 0, 0, 0.10))";
export const linkColor = () => "#ffffffff";
export const iconSize = () => 24;
export const iconColor = () => "#ffffffff";
export const hideEasing = () => "cubic-bezier(0.8,0,1,1)";
export const hideDuration = () => 50; /*                     */
export const headlineFont = () => "700 1rem/1.5rem 'OTTOSans', Arial, Helvetica, sans-serif";
export const headlineColor = () => "#ffffffff";
export const gapY = () => 8;
export const gapX = () => 8;
export const frameSpacing = () => 8;
export const copyFont = () => "400 0.875rem/1.5rem 'OTTOSans', Arial, Helvetica, sans-serif";
export const copyColor = () => "#ffffffff";
export const contextSpacing = () => 4;
export const closeButtonSpacing = () => 8;
export const borderRadius = () => 0.125 * fontSize(); /*                         */
export const backgroundColor = () => "#212121ff";
export const arrowWidth = () => 16;
export const arrowHeight = () => 8;
export const actionSpacingBottom = () => 8;